import { EventType } from "@/analytics/analytics-events";
import {
  OpenChatEventProperties,
  OpenHelpCenterResourceProperties,
} from "@/analytics/help-center-menu-events-properties";
import {
  LATEST_WHATS_NEW_ARTICLE_KEY,
  useCheckWhatsNew,
} from "@/hooks/use-check-whats-new";
import { runtimeConfig } from "@/runtime-config";
import { HelpCenterMenu, codeToLanguageCodes } from "@faro-lotv/flat-ui";
import {
  Analytics,
  useIntercom,
  useLocalizeLanguage,
} from "@faro-lotv/foreign-observers";
import type { JSX } from "react";

/**
 * @returns the Faro HelpCenterMenu configured for the Sphere Viewer app
 */
export function ViewerHelpCenterMenu(): JSX.Element {
  const language = useLocalizeLanguage();

  const helpCenterLanguage = codeToLanguageCodes(language.code);

  const intercom = useIntercom();

  const { newArticle, setNewArticle } = useCheckWhatsNew();

  return (
    <HelpCenterMenu
      onOpenHelpCenter={() => {
        Analytics.track(EventType.openHelpMenu);
      }}
      shouldShowWhatsNewBadge={Boolean(newArticle)}
      onOpenHelpLink={(helpType) => {
        Analytics.track<OpenHelpCenterResourceProperties>(
          EventType.openHelpResource,
          {
            helpType,
          },
        );

        if (helpType === "whats-new") {
          if (newArticle) {
            localStorage.setItem(LATEST_WHATS_NEW_ARTICLE_KEY, newArticle);
          }
          setNewArticle(undefined);
        }
      }}
      openChat={
        intercom
          ? () => {
              Analytics.track<OpenChatEventProperties>(EventType.openChat, {
                hasUnreadMessages: !!intercom.unreadMessagesCount,
              });

              intercom.showMessenger();
            }
          : undefined
      }
      numUnreadMsg={intercom ? intercom.unreadMessagesCount : undefined}
      helpCenterLanguages={helpCenterLanguage}
      sendFeedback={
        runtimeConfig.externalLinks.feedbackForm
          ? () => {
              window.open(runtimeConfig.externalLinks.feedbackForm, "blank");
            }
          : undefined
      }
    />
  );
}
